import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'
import elementZhCN from 'element-ui/lib/locale/lang/zh-CN'
import elementEnUS from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)

const messages = {
  'zh-CN': {
    ...zhCN,
    ...elementZhCN
  },
  'en-US': {
    ...enUS,
    ...elementEnUS
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh-CN',
  messages
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
